// src/pages/info/ContactUs.js
import React, { useEffect, useState } from "react";
import { db } from "../../shared/libs/firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

export default function ContactUs() {
  const [formState, setFormState] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    document.title = "ติดต่อเรา - Encraft";
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitted(false);

    // ตรวจสอบแบบง่าย ๆ ว่ากรอกครบ
    if (!formState.name || !formState.email || !formState.subject || !formState.message) {
      setError("กรุณากรอกข้อมูลให้ครบทุกช่อง");
      return;
    }

    try {
      setSending(true);

      // บันทึกไปที่ collection: contactMessages
      await addDoc(collection(db, "contactMessages"), {
        name: formState.name,
        email: formState.email,
        subject: formState.subject,
        message: formState.message,
        createdAt: serverTimestamp(),
        status: "new",        // ไว้ใช้ filter ว่าอ่านแล้ว / ยังไม่อ่าน
        source: "web-contact" // เผื่ออนาคตมีหลายช่องทาง
      });

      setSubmitted(true);
      setFormState({
        name: "",
        email: "",
        subject: "",
        message: "",
      });
    } catch (err) {
      console.error("Error sending contact message:", err);
      setError("ระบบไม่สามารถส่งข้อความได้ กรุณาลองใหม่อีกครั้ง");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="content-container">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <h1 className="mb-3">ติดต่อเรา</h1>
            <p className="text-muted mb-4">
              หากคุณมีคำถาม ข้อเสนอแนะ หรือสนใจร่วมงานกับ Encraft
              สามารถติดต่อเราได้ผ่านแบบฟอร์มด้านล่าง หรือช่องทางติดต่ออื่น ๆ
            </p>

            <div className="row g-4">
              {/* ข้อมูลติดต่อ */}
              <div className="col-md-5">
                <div className="card border rounded-3 shadow-none h-100">
                  <div className="card-body p-4">
                    <h2 className="h5 mb-3">ช่องทางติดต่อ</h2>
                    <p>
                      เรายินดีรับฟังความคิดเห็นจากผู้อ่าน ผู้เขียน และพาร์ทเนอร์ทุกท่าน
                      ไม่ว่าจะเป็นคำแนะนำ ฟีเจอร์ที่อยากให้มีบนเว็บ
                      หรือโอกาสในการร่วมงานกัน
                    </p>
                    <ul className="list-unstyled mb-4">
                      <li className="mb-2">
                        <strong>Email:</strong>{" "}
                        <a href="mailto:encraft.official@gmail.com">
                          encraft.official@gmail.com
                        </a>
                      </li>
                      <li className="mb-2">
                        <strong>Facebook:</strong>{" "}
                        <a href="https://www.facebook.com/profile.php?id=61579275334120" target="_blank" rel="noreferrer">
                          Encraft
                        </a>
                      </li>
                      <li className="mb-2">
                        <strong>Instagram:</strong>{" "}
                        <a href="https://www.instagram.com/encraft_org?fbclid=IwY2xjawMXVXNleHRuA2FlbQIxMABicmlkETFldkhhTkZUcmVRbDZ2QmM2AR6xsRCvZxMncPoFUFT4s3DvCaxIvfuJMCUBdDCwItuDjtIcg9oOs9fmD9Nvow_aem_VB-bV8RBjyXf-fF-XldwCA" target="_blank" rel="noreferrer">
                          encraft_org
                        </a>
                      </li>
                      <li className="mb-2">
                        <strong>เว็บไซต์:</strong>{" "}
                        <a href="https://encraft.org" target="_blank" rel="noreferrer">
                          encraft.org
                        </a>
                      </li>
                    </ul>
                    <p className="small text-muted mb-0">
                      * ขณะนี้ Encraft อยู่ในช่วงเริ่มต้นการพัฒนา
                      หากการตอบกลับล่าช้าเล็กน้อย ต้องขออภัยมา ณ ที่นี้ด้วย
                    </p>
                  </div>
                </div>
              </div>

              {/* ฟอร์มติดต่อ */}
            {/*   <div className="col-md-7">
                <div className="card border rounded-3 shadow-none">
                  <div className="card-body p-4 p-md-5">
                    <h2 className="h5 mb-3">ส่งข้อความหาเรา</h2>

                    {submitted && (
                      <div className="alert alert-success py-2 small" role="alert">
                        ขอบคุณสำหรับข้อความของคุณ ระบบได้รับคำถาม/ข้อเสนอแนะแล้ว
                      </div>
                    )}

                    {error && !submitted && (
                      <div className="alert alert-danger py-2 small" role="alert">
                        {error}
                      </div>
                    )}

                    <form onSubmit={handleSubmit} noValidate>
                      <div className="mb-3">
                        <label className="form-label">ชื่อของคุณ</label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          value={formState.name}
                          onChange={handleChange}
                          placeholder="กรอกชื่อของคุณ"
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">อีเมลสำหรับติดต่อกลับ</label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          value={formState.email}
                          onChange={handleChange}
                          placeholder="your@email.com"
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">หัวข้อ</label>
                        <input
                          type="text"
                          className="form-control"
                          name="subject"
                          value={formState.subject}
                          onChange={handleChange}
                          placeholder="เรื่องที่ต้องการติดต่อ"
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">ข้อความ</label>
                        <textarea
                          className="form-control"
                          name="message"
                          rows="4"
                          value={formState.message}
                          onChange={handleChange}
                          placeholder="พิมพ์ข้อความของคุณที่นี่"
                          required
                        />
                      </div>

                      <div className="d-flex justify-content-end">
                        <button
                          type="submit"
                          className="btn btn-encraft"
                          disabled={sending}
                        >
                          {sending ? "กำลังส่ง..." : "ส่งข้อความ"}
                        </button>
                      </div>
                    </form>

                    <p className="small text-muted mt-3 mb-0">
                      ข้อมูลที่คุณส่งผ่านแบบฟอร์มนี้
                      จะถูกใช้เพื่อการตอบกลับและประสานงานเท่านั้น
                      รายละเอียดเพิ่มเติมดูได้จาก{" "}
                      <a href="/privacy">นโยบายความเป็นส่วนตัว</a>.
                    </p>
                  </div>
                </div>
              </div> */}
            </div>
            {/* row g-4 */}
          </div>
        </div>
      </div>
    </div>
  );
}

